import { slugify } from "healthex-common/utils";
const _patientConsentRoutes = [
    "ENROLLMENT_WELCOME",
    "ENROLLMENT_REQUEST_DETAILS_POPUP",
    "ENROLLMENT_LOGIN",
    "ENROLLMENT_DECLINED_ACCESS",
    "ENROLLMENT_IDENTITY_VERIFIED",
    "ENROLLMENT_PARTICIPATION_SIGNATURE",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_IN_PARTICIPANT_CONSENT_INTERIM_PAGE",
    "ENROLLMENT_PDDA_RECORD_LOCATION",
    "ENROLLMENT_PDDA_RECORD_LOCATION_SCREENSHOT_REVIEW_AND_SHARE",
    "ENROLLMENT_CONFIRMED",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_OUT_INTERIM_PAGE",
    "ENROLLMENT_PARTICIPATION_SIGNATURE_SCREENSHOT_PREVIEW_DECLINED",
    "ENROLLMENT_DECLINED",
    "ENROLLMENT_WELCOME_BACK",
    "ENROLLMENT_EXCLUDED",
];
export const patientConsentRouteValues = _patientConsentRoutes;
export function patientConsentRouteParts(route) {
    const parts = route.split("_");
    const flow = parts[0];
    const step = slugify(parts.slice(1).join("_"));
    return { flow, step };
}
export function patientConsentRouteFromParts(parts) {
    const { flow, step } = parts;
    if (!step)
        return null;
    const patientConsentManagerRoute = `${flow}_${step}`;
    if (patientConsentRouteValues.includes(patientConsentManagerRoute)) {
        return patientConsentManagerRoute;
    }
    else {
        return null;
    }
}
